<template>
  <div class="klickbox-list clearfix">
    <div class="container no-padding">
      <list-header></list-header>
      <ul class="kp-list-item" v-if="boxes.length > 0">
        <item v-for="(box, index) in boxes" :box="box" :index="index"></item>
      </ul>
      <empty v-else></empty>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ListHeader from './ListHeader.vue';
import Item from './item/Main.vue';
import Empty from '../Empty.vue';

export default {
  components: {
    ListHeader,
    Item,
    Empty,
  },
  computed: mapGetters({
    boxes: 'boxList',
  }),
  created() {
    this.$store.dispatch('boxGetAll');
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?2e009eab
 **/